import { defineComponent as A, openBlock as H, createElementBlock as o, mergeProps as Z, unref as e, renderSlot as d, createElementVNode as a, createCommentVNode as M } from "vue";
import { useScalarIcon as i } from "../hooks/useScalarIcon.js";
const p = { key: 0 }, u = { key: 1 }, v = { key: 2 }, m = { key: 3 }, g = { key: 4 }, f = { key: 5 }, k = {
  name: "ScalarIconDeviceTablet"
}, y = /* @__PURE__ */ A({
  ...k,
  props: {
    label: {},
    weight: {}
  },
  setup(n) {
    const V = n, { bind: r, weight: l } = i(V);
    return (s, t) => (H(), o("svg", Z({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      fill: "currentColor"
    }, e(r)), [
      d(s.$slots, "default"),
      e(l) === "bold" ? (H(), o("g", p, t[0] || (t[0] = [
        a("path", { d: "M192,20H64A28,28,0,0,0,36,48V208a28,28,0,0,0,28,28H192a28,28,0,0,0,28-28V48A28,28,0,0,0,192,20ZM60,84H196v88H60Zm4-40H192a4,4,0,0,1,4,4V60H60V48A4,4,0,0,1,64,44ZM192,212H64a4,4,0,0,1-4-4V196H196v12A4,4,0,0,1,192,212Z" }, null, -1)
      ]))) : e(l) === "duotone" ? (H(), o("g", u, t[1] || (t[1] = [
        a("path", {
          d: "M208,64V192H48V64Z",
          opacity: "0.2"
        }, null, -1),
        a("path", { d: "M192,24H64A24,24,0,0,0,40,48V208a24,24,0,0,0,24,24H192a24,24,0,0,0,24-24V48A24,24,0,0,0,192,24ZM56,72H200V184H56Zm8-32H192a8,8,0,0,1,8,8v8H56V48A8,8,0,0,1,64,40ZM192,216H64a8,8,0,0,1-8-8v-8H200v8A8,8,0,0,1,192,216Z" }, null, -1)
      ]))) : e(l) === "fill" ? (H(), o("g", v, t[2] || (t[2] = [
        a("path", { d: "M192,24H64A24,24,0,0,0,40,48V208a24,24,0,0,0,24,24H192a24,24,0,0,0,24-24V48A24,24,0,0,0,192,24ZM64,40H192a8,8,0,0,1,8,8v8H56V48A8,8,0,0,1,64,40ZM192,216H64a8,8,0,0,1-8-8v-8H200v8A8,8,0,0,1,192,216Z" }, null, -1)
      ]))) : e(l) === "light" ? (H(), o("g", m, t[3] || (t[3] = [
        a("path", { d: "M192,26H64A22,22,0,0,0,42,48V208a22,22,0,0,0,22,22H192a22,22,0,0,0,22-22V48A22,22,0,0,0,192,26ZM54,70H202V186H54ZM64,38H192a10,10,0,0,1,10,10V58H54V48A10,10,0,0,1,64,38ZM192,218H64a10,10,0,0,1-10-10V198H202v10A10,10,0,0,1,192,218Z" }, null, -1)
      ]))) : e(l) === "regular" ? (H(), o("g", g, t[4] || (t[4] = [
        a("path", { d: "M192,24H64A24,24,0,0,0,40,48V208a24,24,0,0,0,24,24H192a24,24,0,0,0,24-24V48A24,24,0,0,0,192,24ZM56,72H200V184H56Zm8-32H192a8,8,0,0,1,8,8v8H56V48A8,8,0,0,1,64,40ZM192,216H64a8,8,0,0,1-8-8v-8H200v8A8,8,0,0,1,192,216Z" }, null, -1)
      ]))) : e(l) === "thin" ? (H(), o("g", f, t[5] || (t[5] = [
        a("path", { d: "M192,28H64A20,20,0,0,0,44,48V208a20,20,0,0,0,20,20H192a20,20,0,0,0,20-20V48A20,20,0,0,0,192,28ZM52,68H204V188H52ZM64,36H192a12,12,0,0,1,12,12V60H52V48A12,12,0,0,1,64,36ZM192,220H64a12,12,0,0,1-12-12V196H204v12A12,12,0,0,1,192,220Z" }, null, -1)
      ]))) : M("", !0)
    ], 16));
  }
});
export {
  y as default
};
